import { Link } from 'react-router-dom';
import { useAppAuth } from '../components/AuthContext.jsx';

const MAP = [
  {
    title: 'Makléř (mobilní aplikace)',
    items: [
      ['Přihlášení a první přihlášení', 'z pozvánky, 2 zaškrtnutí: podmínky a informace o údajích'],
      ['Dnes – denní zápis', 'do 3 minut · 12 zdrojů · omluvená nepřítomnost'],
      ['Zapsat obchod', 'prodej nebo nájem'],
      ['Týden – plán', 'plán aktivit a semafor'],
      ['Cesta', 'úroveň, tempo, milníky a pevné body'],
      ['Trychtýř', 'zakázky a prohlídky'],
      ['Profil', 'kohorta, huddle, review, denní připomínka'],
    ],
  },
  {
    title: 'Vedení (JR a JCH)',
    items: [
      ['Přehled', 'semafor, nábory, provize, upozornění', '/dashboard'],
      ['Detail makléře', 'plán, týden, profil a historie', '/dashboard/database'],
      ['Zařazení do úrovně', 'návrh Drillu a zápis JR', '/dashboard/level-assignment'],
      ['Kalendář a rytmus', 'pevné body na 30–90 dní', '/dashboard/kalendar'],
      ['Milníky', 'hovory do 24 h a osobní setkání', '/dashboard/milniky'],
      ['Týdenní report', 'report pro JCH', '/dashboard/report'],
    ],
  },
  {
    title: 'Správa',
    items: [
      ['Co kdy udělat', 'úkoly, rytmus a stav dat', '/dashboard/sprava'],
      ['Import provizí', 'soubor z Maxisu nebo ruční zadání', '/dashboard/import'],
      ['Účty a skupiny', 'pozvánky, skupiny, ukončení', '/accounts'],
      ['Denní připomínka', 'push v 18:00', '/dashboard/pripominka'],
      ['Parametry', 'jediné místo pro čísla', '/dashboard/parametry'],
      ['KPI', 'devět ukazatelů systému', '/dashboard/kpi'],
    ],
  },
];

export default function SystemMap() {
  const { user } = useAppAuth();
  return (
    <section className="dashboard">
      <div className="dashboard__header">
        <div>
          <h1 className="dashboard__title">Mapa systému</h1>
          <p className="dashboard__lead">Všechny obrazovky Drillu na jednom místě.</p>
        </div>
      </div>
      {MAP.map((g) => (
        <div className="card" key={g.title}>
          <h2 className="card__title">{g.title}</h2>
          <ul className="jr-list">
            {g.items.map(([name, note, to]) => (
              <li key={name}>
                {to && (user?.role === 'JCH' || to !== '/accounts') ? <Link to={to}>{name}</Link> : <strong>{name}</strong>}
                {' '}– <small>{note}</small>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </section>
  );
}
